import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExtractPdfPages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#AA67FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.333 7.467c0-.747 0-1.12.146-1.406.127-.25.331-.455.582-.582.285-.146.659-.146 1.406-.146h5.066c.747 0 1.12 0 1.406.146.25.127.454.331.582.582.146.285.146.659.146 1.406v5.066c0 .747 0 1.12-.146 1.406-.128.25-.332.454-.582.582-.286.146-.659.146-1.406.146H7.467c-.747 0-1.12 0-1.406-.146a1.33 1.33 0 0 1-.582-.582c-.146-.286-.146-.659-.146-1.406z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.333 11.467c0-.747 0-1.12.146-1.406.127-.25.331-.455.582-.582.286-.146.659-.146 1.406-.146h5.066c.747 0 1.12 0 1.406.146.25.127.454.331.582.582.146.286.146.659.146 1.406v5.066c0 .747 0 1.12-.146 1.406-.128.25-.332.454-.582.582-.286.146-.659.146-1.406.146h-5.066c-.747 0-1.12 0-1.406-.146a1.33 1.33 0 0 1-.582-.582c-.146-.286-.146-.659-.146-1.406z"
    />
  </svg>
);
export default SvgExtractPdfPages;
